import { useState } from "react";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import "../landingPage.css";

function LandingPageStory() {
  const [showDropdown1, setShowDropdown1] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [showDropdown3, setShowDropdown3] = useState(false);
  const [showDropdown4, setShowDropdown4] = useState(false);

  return (
    <div className="body" style={{ marginTop: "-8rem" }}>
      {/* ✅ STORYLINE */}
      <div className="storyline" id="storyline">
        <h1 className="subTitle" data-aos="fade-up">
          Das ist
        </h1>
        <h1 className="heroTitle" data-aos="fade-up">
          KSB-IT
        </h1>

        {/* ✅ SECTION 1 */}
        <div className="section" data-aos="fade-up">
          <div>
            <img
              className="left"
              src="./static/images/story/currentApps.png"
              alt="current apps"
            />
          </div>
          <div className="rightText">
            <p className="text">
              ksb-it bietet eine Plattform für Lernende um WebApplikationen in
              einer echten Umgebung zu entwickeln. Dies ist gedacht für
              begeisterte Programmierer*innen oder für Maturaarbeitsprojekte.
            </p>
          </div>
        </div>

        {/* ✅ SECTION 2 */}
        <div className="section" data-aos="fade-left">
          <div className="leftText">
            <p className="text">
              Unsere Umgebung bietet ein robustes Setting, bei der auf
              allgemeine Funktionen wie ein implementierter Loginprozess
              gemeinsam genutzt werden kann...
            </p>
          </div>
          <div>
            <img
              className="right"
              src="./static/images/story/Login.png"
              alt="login"
            />
          </div>
        </div>

        {/* ✅ SECTION 3 */}
        <div className="section" data-aos="fade-right">
          <div>
            <img
              className="left"
              src="./static/images/story/storyline1.png"
              alt="storyline"
            />
          </div>
          <div className="rightText">
            <p className="text">
              Husibuech zeigt beispielsweise auf, wie die zeitliche Belastung
              bei Lernenden aussieht. Je genauer Aufgaben erfasst werden, umso
              besser können wir visualisieren, was das bedeutet.
            </p>
          </div>
        </div>

        {/* ✅ SECTION 4 */}
        <div className="section" data-aos="fade-left">
          <div className="leftText">
            <p className="text">
              Unser Prüfungplan bietet Lernenden und Lehrpersonen eine klare
              Übersicht über die Prüfungen, die anstehen.
            </p>
          </div>
          <div>
            <img
              className="right"
              src="./static/images/story/storyline6.png"
              alt="planung"
            />
          </div>
        </div>

        {/* ✅ SECTION 5 */}
        <div className="section" data-aos="zoom-in">
          <div>
            <img
              className="left"
              src="./static/images/story/chatApp.png"
              alt="chat"
            />
          </div>
          <div className="rightText">
            <p className="text">
              Und eine funktionierende ChatApp ohne 2-FA ist in Ausarbeitung...
            </p>
          </div>
        </div>
      </div>

      {/* ✅ ROADMAP */}
      <div className="roadmap" data-aos="fade-up">
        <h1 className="subTitle">ROADMAP</h1>
        <h1 className="title">Neu bei KSB-IT...</h1>

        <div className="section">
          <h3>Registrieren</h3>
          <ul>
            <li>
              Du registrierst dich mit deiner SLUZ-Adresse und erhältst danach
              eine E-Mail zur Verifikation.
            </li>
          </ul>
        </div>
      </div>

      {/* ✅ TEAM */}
      <div className="team">
        <h1 className="subTitle" data-aos="fade-up">
          TEAM
        </h1>
        <h1 className="title" data-aos="fade-up">
          Contributors
        </h1>

        <div className="teamInner">
          <div className="teamMember" data-aos="fade-up">
            <img src="./static/images/team/Maverick.png" alt="team-member" />
            <h1>Mr. P</h1>
            <h2>Creator | Admin</h2>
            <div className="line" />
            <h3>English & IT Teacher</h3>
            <h3>roman.pfaeffli@sluz.ch</h3>
          </div>

          <div className="teamMember" data-aos="fade-up" data-aos-delay="150">
            <img src="./static/images/team/Iceman.png" alt="team-member" />
            <h1>Ms. H</h1>
            <h2>Chat-Creator</h2>
            <div className="line" />
            <h3>Maturaarbeitsprojekt</h3>
          </div>
        </div>
      </div>

      {/* ✅ FAQ */}
      <div className="faq">
        <h1 className="subTitle" data-aos="fade-up">
          FAQ
        </h1>
        <h1 className="title" data-aos="fade-up">
          Häufige Fragen
        </h1>

        {/* Q1 */}
        <div
          className="question"
          onClick={() => setShowDropdown1(!showDropdown1)}
        >
          <div className="questionRow">
            <h1>Was ist KSB-IT?</h1>
            {showDropdown1 ? <CheckBox /> : <CheckBoxOutlineBlank />}
          </div>
          {showDropdown1 && (
            <h2>Plattform für realistische WebApplikationen.</h2>
          )}
        </div>

        <div className="line" />

        {/* Q2 */}
        <div
          className="question"
          onClick={() => setShowDropdown2(!showDropdown2)}
        >
          <div className="questionRow">
            <h1>Wer kann KSB-IT nutzen?</h1>
            {showDropdown2 ? <CheckBox /> : <CheckBoxOutlineBlank />}
          </div>
          {showDropdown2 && (
            <h2>Aktuell für Lernende und Lehrpersonen im Kanton Luzern.</h2>
          )}
        </div>

        <div className="line" />

        {/* Q3 */}
        <div
          className="question"
          onClick={() => setShowDropdown3(!showDropdown3)}
        >
          <div className="questionRow">
            <h1>Kostet KSB-IT?</h1>
            {showDropdown3 ? <CheckBox /> : <CheckBoxOutlineBlank />}
          </div>
          {showDropdown3 && <h2>Nein.</h2>}
        </div>

        <div className="line" />

        {/* Q4 */}
        <div
          className="question"
          onClick={() => setShowDropdown4(!showDropdown4)}
        >
          <div className="questionRow">
            <h1>Verwendet Husibuech SchulNetz Daten?</h1>
            {showDropdown4 ? <CheckBox /> : <CheckBoxOutlineBlank />}
          </div>
          {showDropdown4 && (
            <h2>Nein, unabhängiges System mit Einwilligung.</h2>
          )}
        </div>

        <div className="line" />
      </div>

      {/* ✅ FOOTER */}
      <div className="footer" data-aos="fade-up">
        <h1>Copyright © KSB 2024</h1>
      </div>
    </div>
  );
}

export default LandingPageStory;
